import {createMuiIcon} from "./createMuiIcon";


export const AuditsIcon = createMuiIcon("fact_check", "AuditsIcon");
